package com.eladfinish.bible.contest.screens.search.usecases

import androidx.compose.ui.text.input.TextFieldValue

class GetTextToCopyFromTextFieldUseCase {

    operator fun invoke(
        current: TextFieldValue,
    ): String {
        val start = current.selection.min
        val end = current.selection.max

        return if (start != end) {
            current.text.substring(start, end)
        } else {
            current.text
        }
    }
}
